<template>
  <section class="page-stack grid-stack grid-gap-page-section">
    <article class="page-panel page-panel--mobile-unframed grid-stack grid-gap-20">
      <h2>{{ pageTitle }}</h2>

      <v-table class="table">
        <thead>
          <tr>
            <th class="text-mid">Naziv</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="document in documentListState.documents"
            :key="document.id"
          >
            <td class="body-1-regular">
              <router-link
                :to="{ name: 'event-document-detail', params: { documentId: document.id } }"
              >
                {{ document.name }}
              </router-link>
            </td>
          </tr>

          <tr v-if="documentListState.isLoadingDocuments || !documentListState.documents.length">
            <td
              class="table__empty"
            >
              {{ documentListState.isLoadingDocuments ? 'Učitavanje dokumenata...' : 'Nema dokumenata.' }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </article>
  </section>
</template>

<script setup>
import { computed, onMounted, reactive } from 'vue'
import { useRoute } from 'vue-router'

import { apiClient } from '../../services/apiClient'
import { showRequestErrorToast } from '../../store/appStore'

const route = useRoute()
const documentListState = reactive({
  documents: [],
  isLoadingDocuments: true,
})

const pageTitle = computed(() => route.meta.title)

onMounted(loadDocumentsAsync)

async function loadDocumentsAsync () {
  documentListState.isLoadingDocuments = true

  try {
    documentListState.documents = await apiClient.getAsync('/api/document-types')
  } catch (error) {
    console.error('Failed to load documents.', error)
    showRequestErrorToast(error, 'Dokumente nije bilo moguće učitati.')
  } finally {
    documentListState.isLoadingDocuments = false
  }
}
</script>
